import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeading from "@/components/PageHeading/PageHeading";
import useCapabilities from "@/hooks/useCapabilities";
import { useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { getGrpNavLinks, getVisibleGrpTabs } from "./_utils";

export default function GrpTabLayout({ children }: { children?: React.ReactNode }) {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const { capabilities, loaded } = useCapabilities();
  const currentPath = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;

  return (
    <AppLayout interior navLinks={getGrpNavLinks()}>
      <Breadcrumb title="Golf Retirement Plus" backLink={{ to: "/billing/finance" }} />
      <PageHeading title="Contributions" compact />
      {loaded ? (
        <Tabs
          tabItems={getVisibleGrpTabs(capabilities).map(({ label, to }) => ({
            label,
            onClick: () => navigate(to),
            active: currentPath === to
          }))}
        />
      ) : null}
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
